// extracted by mini-css-extract-plugin
export default {"btn":"KYUhJ","ffContainer":"sPkB3","ffNumber":"g+D6m"};